'use strict';

define(['app'], function (app) {
  var PowerReviewQASnippet = function PowerReviewQASnippet() {

    var component = {};

    var COMPONENT_ID_PREFIX = 'pr-qa-snippet-';

    var _subscribeChannels = {
      variantChange: 'productReviewStars/update'
    };

    var _init = function _init(element) {
      component.element = element;
      component.subscribe();
    };

    var _subscribe = function _subscribe() {
      app.subscribe(component.subscribeChannels.variantChange, function (sku) {
        component.updateComponentId(sku);
      });
    };

    var _updateComponentId = function _updateComponentId(sku) {
      component.element.id = '' + COMPONENT_ID_PREFIX + sku;
    };

    component.init = _init;
    component.subscribe = _subscribe;
    component.subscribeChannels = _subscribeChannels;
    component.updateComponentId = _updateComponentId;

    return component;
  };
  return PowerReviewQASnippet;
});
//# sourceMappingURL=powerReviewQASnippet.js.map
